module.exports = __webpack_public_path__ + "static/media/slide-03.cc314ecb.jpg";